<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('feedback.feedback')" center width="520px" @close="close">
    <!-- :close-on-click-modal="false" -->
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-l-c-fs">

          <input class="dialog-input" type="text" :placeholder="$t('feedback.title')" v-model="feedback.title" />
          <textarea class="dialog-textarea mytextarea" :placeholder="$t('feedback.content')" v-model="feedback.content" />
      
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'DialogFeedback',
  data() {
    return {
      isShowDialog: false,

      feedback: {
        title: '',
        content: '',
        parentId: 0,
      }, // 反馈表单
    }
  },
  methods: {
    ...mapMutations([
      'newFeedbackComing_x_save',
    ]),
    open() {
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.feedback = {
        title: '',
        content: '',
        parentId: 0,
      }
    },

    // 提交
    async submit() {
      // console.log(this.feedback)
      let { title, content } = this.feedback
      if (title && content) {
        let rD = JSON.parse(JSON.stringify(this.feedback))
        rD.shopId = this.currentShopId
        rD.dealPerson = this.user_x.nickName
        rD.type = 1
        rD.companyId = this.shop_x.companyId
        const _R = await this.newData('feedback', rD)

        this.close()

        if (this.currentRoute === 'feedback') {
          this.newFeedbackComing_x_save((new Date()).getTime())
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.dialog-square{
  .dialog-input{width: 366px;height: 50px;margin: 60px 0 20px;padding: 12px;box-sizing: border-box;}
  .dialog-textarea{width: 366px;height: 130px;}
}
</style>